module.exports = __webpack_public_path__ + "static/media/live_games.ec9933dc.svg";